import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Trending from "@/pages/home/components/Trending";
import Reactions from "@/pages/home/components/Reactions";
import Analysis from "@/pages/home/components/Analysis";
import Timeline from "@/pages/home/components/Timeline";
import Glossary from "@/pages/home/components/Glossary";
import Faq from "@/pages/home/components/Faq";
import About from "@/pages/home/components/About";
import Newsletter from "@/pages/home/components/Newsletter";
import Footer from "@/pages/home/components/Footer";
import BackToTop from "@/pages/home/components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950 antialiased">
      <Navbar />
      <main>
        <Hero />
        <Trending />
        <Reactions />
        <Analysis />
        <Timeline />
        <Glossary />
        <Faq />
        <About />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}